export default {
  header: "My Books Page",
  view: "Books"
  };
